import { proxyCustomElement, HTMLElement, createEvent, h, Fragment } from '@stencil/core/internal/client';
import { s as state } from './index3.js';
import { d as defineCustomElement$2 } from './button-base2.js';
import { d as defineCustomElement$1 } from './nl-select2.js';

import { baseCss } from './css.js';
const nlImportFlowCss = baseCss;

const NlImportFlowStyle0 = nlImportFlowCss;

const NlImportFlow = /*@__PURE__*/ proxyCustomElement(class NlImportFlow extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.nlImportAccount = createEvent(this, "nlImportAccount", 7);
        this.nlExportKeys = createEvent(this, "nlExportKeys", 7);
        this.titleInfo = 'Back up your keys';
        this.titleImport = 'Choose a service';
        this.services = [];
        this.isContinued = false;
        this.isKeyBackup = false;
        this.isCopy = false;
    }
    handleDomainSelect(event) {
        const s = this.services.find(s => s.domain === event.detail);
        state.nlImport = s;
    }
    handleCreateAccount(e) {
        e.preventDefault();
        this.nlImportAccount.emit(state.nlImport);
    }
    handleContinue() {
        this.isContinued = true;
    }
    handleContinueKeyBackup() {
        this.isKeyBackup = true;
    }
    async copyToClipboard() {
        this.nlExportKeys.emit();
        this.isCopy = true;
        setTimeout(() => {
            this.isCopy = false;
        }, 1500);
    }
    render() {
        if (!this.isContinued && !this.isKeyBackup) {
            return (h("div", { class: "p-4 overflow-y-auto" }, h("h1", { class: "nl-title font-bold text-center text-2xl" }, this.titleInfo), h("p", { class: "nl-description font-light text-sm pt-2 pb-2 max-w-96 mx-auto" }, "Nostr profiles are controlled by cryptographic keys.", h("br", null), h("br", null), "Your keys are currently only stored in this browser tab, and may be lost if you close it.", h("br", null), h("br", null), "You should backup your keys.", h("br", null), h("br", null), "We recommend to import your keys into a key store service, to protect them and to use with other apps."), h("div", { class: "ml-auto mr-auto mb-2 w-72" }, h("button-base", { onClick: () => this.handleContinue(), titleBtn: "Import to key store" })), h("div", { class: "ml-auto mr-auto w-72" }, h("button-base", { onClick: () => this.handleContinueKeyBackup(), titleBtn: "Export keys" }))));
        }
        if (this.isKeyBackup) {
            return (h("div", { class: "p-4 overflow-y-auto" }, h("h1", { class: "nl-title font-bold text-center text-2xl" }, "Key export"), h("p", { class: "nl-description font-light text-sm pt-2 pb-2 max-w-96 mx-auto" }, "Copy your keys and store them in a safe place, like a password manager.", h("br", null), h("br", null), "You can sign into other Nostr apps by pasting your keys into them.", h("br", null), h("br", null), "Your keys must be kept secret, never share them with anyone."), h("div", { class: "max-w-72 mx-auto" }, h("div", { class: "ml-auto mr-auto mb-2 w-72" }, h("button-base", { onClick: () => this.copyToClipboard(), titleBtn: this.isCopy ? 'Copied!' : 'Copy to clipboard' })))));
        }
        const options = this.services.filter(s => s.canImport).map(s => ({ name: s.domain, value: s.domain }));
        return (h(Fragment, null, h("div", { class: "p-4 overflow-y-auto" }, h("h1", { class: "nl-title font-bold text-center text-2xl" }, this.titleImport), h("p", { class: "nl-description font-light text-center text-sm pt-2 max-w-96 mx-auto" }, "Your Nostr keys will be imported into the service you choose. You will manage your keys on their website.")), h("div", { class: "max-w-72 mx-auto mb-5" }, h("div", { class: "mb-0.5" }, h("nl-select", { onSelectDomain: e => this.handleDomainSelect(e), selected: 0, options: options })), h("p", { class: "nl-title font-light text-sm mb-2" }, "Default provider is a fine choice to start with."), h("div", { class: "ps-4 pe-4 overflow-y-auto" }, h("p", { class: "nl-error font-light text-center text-sm max-w-96 mx-auto" }, state.error)), h("button-base", { disabled: state.isLoading, onClick: e => this.handleCreateAccount(e), titleBtn: "Start importing" }, state.isLoading ? (h("span", { slot: "icon-start", class: "animate-spin-loading inline-block w-4 h-4 border-[3px] border-current border-t-transparent text-slate-900 dark:text-gray-300 rounded-full", role: "status", "aria-label": "loading" })) : (h("svg", { slot: "icon-start", style: { display: 'none' }, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor" }, h("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z" })))))));
    }
    static get style() { return NlImportFlowStyle0; }
}, [0, "nl-import-flow", {
        "titleInfo": [1025, "title-info"],
        "titleImport": [1, "title-import"],
        "services": [16],
        "isContinued": [32],
        "isKeyBackup": [32],
        "isCopy": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-import-flow", "button-base", "nl-select"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-import-flow":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlImportFlow);
            }
            break;
        case "button-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "nl-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NlImportFlow as N, defineCustomElement as d };

//# sourceMappingURL=nl-import-flow2.js.map